/** 禮遇狀態 */
export enum CourtesyStatus {
  /** 未指派 */
  N = 'N',
  /** 已指派 */
  A = 'A',
  /** 歸還 */
  W = 'W',
  /** 過期 */
  E = 'E',
  /** 核銷 */
  V = 'V',
  /** 部分核銷 */
  S = 'S',
  /** 申請中 */
  P = 'P',
  /** 作業中 */
  R = 'R',
  /** 重新指派 */
  B = 'B',
  /** 已綁定行程 */
  U = 'U',
  /** 作廢 */
  X = 'X',
  /** 客服處理中 */
  L = 'L'
}
